import React from "react";
import Constants from "../../../constants/text-constants";
import PropTypes from "prop-types";
import LocationForm from "../../molecules/LocationForm";
import LocationHandler from "../../../services/api/locationHandler";
import { useMst } from "../../../hooks/useMst";

const AddLocation = (props) => {
    const { locationStore } = useMst();
    const { onClose } = props;

    const onSaveAddLocation = async (location) => {
        try {
            await LocationHandler.createNewLocation(location);

            // Add location to store
            locationStore.addLocation(location);
            onClose();
            return true;
        } catch {
            return false;    
        }
    }

    return (
        <LocationForm
            saveButtonText={Constants.ADD_LOCATION}
            onCancel={onClose}
            onSave={onSaveAddLocation}
            title={Constants.ADD_LOCATION}
            subTitle={Constants.TELL_US_WHERE_CALLS}
            failureMessage={Constants.FAILED_TO_ADD_LOCATION}  
        />
    );
}

AddLocation.propTypes = {
    onClose: PropTypes.func,
};

export default AddLocation;